
export class BufferingAbortedError extends Error {
    override name = 'BufferingAbortedError';
    classType: string;
    parentIndex: number;

    constructor(classType: string, parentIndex: number, reason: string) {
        super('Aborted buffering because ' + reason);
        this.classType = classType;
        this.parentIndex = parentIndex;
    }
}

export class FailedToLoadError extends Error {
    #metadata = {};
    constructor(message: string, metadata = {}) {
        super(message);
        this.#metadata = metadata;
    }

    get metadata() {
        return this.#metadata;
    }
}
